export const expertPreviousPlanCard_style = {
  cardRootSx: {
    borderRadius: '8px',
  },
};
